import { useMutation, useQueryClient } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

interface UpdateTicketPayload {
    title: string;
    description: string;
}

export const updateTicket = async (id: number, payload: UpdateTicketPayload) => {
    try {
        const response = await Axios.put(`/tickets/${id}/`, payload);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useUpdateTicket = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, payload }: { id: number; payload: UpdateTicketPayload }) => updateTicket(id, payload),
        onSuccess: (_, variables) => {
            // Invalidate and refetch tickets query to update the list
            queryClient.invalidateQueries({ queryKey: ["get-tickets"] });
            // Invalidate and refetch the specific ticket detail query
            queryClient.invalidateQueries({ queryKey: ["get-ticket-detail", variables.id] });
        },
    });
};